import { Injectable } from '@angular/core';
import { ApiService } from '../../common/api.service';
import { Observable } from 'rxjs';
import { ROUTES } from '../../server-route';

@Injectable({
  providedIn: 'root'
})
export class UserActivityServiceService extends ApiService{


  fetchActivityReport(queryParams: any): Observable<any>{
    return this.get(ROUTES.USER_ACTIVITY_REPORT, {
      params: queryParams
    })
  }

  fetchRoletypes(): Observable<any>{
    return this.get(ROUTES.USER_ROLE_TYPES)
  }

  fetchIvDepositReport(queryParams: any): Observable<any>{
    return this.get(ROUTES.IV_DEPOSIT_REPORT, {
      params: queryParams
    })
  }

}
